import { BasePropertyApi } from './base-api.interface';
import { getShadowData } from './get-common-properties';
import { updateShadowData } from './update-common-properties';

export const shadowAPI: BasePropertyApi = {
  get: getShadowData,
  update: updateShadowData,
};
